import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';

import SubNav from 'components/SubNav/quick';
import { updateQuickPort } from 'actions/quickSubs';
import { fetchQuickPortStatus } from 'api';
import Spinner from 'components/Spinner';
import FormError from 'components/FormError';
import QuickPortForm from 'components/PortForm/quick';
import { getSubmitStatus } from 'reducers';
import { quickSubPage } from 'decorators/subPage';

class UpdatePort extends Component {
  state = {
    portInfo: null,
    portInfoErr: null,
    loading: false,
  };
  componentDidMount() {
    this.loadPortInfo();
  }

  componentDidUpdate(oldProps) {
    if (oldProps.subId !== this.props.subId) {
      this.loadPortInfo();
    }
  }

  loadPortInfo = () => {
    const { subId } = this.props;

    this.setState({ loading: true });

    fetchQuickPortStatus(subId)
      .then((res) => {
        this.setState({ portInfo: res.data });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  handleSubmit = (values) => {
    const { subId, updateQuickPort } = this.props;
    return updateQuickPort(subId, values).then(() =>
      toast.success('Port update requested'),
    );
  };

  getInitialValues = (port) => {
    if (!port || !port?.number_ports?.[0]) {
      return {};
    }

    const numPort = port?.number_ports?.[0];
    const address = port?.addresses?.[0];

    return {
      carrier_account: numPort?.carrier_account || '',
      carrier_password: numPort?.carrier_password || '',
      street: address?.address1 || '',
      city: address?.city || '',
      state: address?.state || '',
      zip_code: address?.zip || '',
    };
  };

  render() {
    const { loading, portInfoErr, portInfo } = this.state;
    const { saveStatus } = this.props;

    let initialValues = this.getInitialValues(portInfo);

    const numPort = portInfo?.number_ports?.[0];
    const showPortMessage = numPort?.external_port_message || numPort?.status;

    return (
      <div>
        <h1>Update Quick Port</h1>
        <SubNav />
        {showPortMessage && (
          <p>
            <b>Status:</b> {numPort?.status}
            <br />
            <b>External Port Message:</b> {numPort?.external_port_message}
          </p>
        )}
        <br />
        {portInfoErr ? (
          <FormError error={portInfoErr} />
        ) : (
          <QuickPortForm
            onSubmit={this.handleSubmit}
            initialValues={initialValues}
            saveStatus={saveStatus}
            isUpdate
          />
        )}
        <Spinner showLoader={loading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  saveStatus: getSubmitStatus(state, 'port'),
});

const mapDispatchToProps = {
  updateQuickPort,
};

export default quickSubPage(
  connect(mapStateToProps, mapDispatchToProps)(UpdatePort),
);
